import { createFileRoute } from "@tanstack/react-router";
import { AccessDenied } from "@/components/auth/AccessDenied";

export const Route = createFileRoute("/_authenticated/access-denied")({
  component: AccessDeniedPage,
});

function AccessDeniedPage() {
  return <AccessDenied variant="route" />;
}
